import script from "./Metodologias.vue?vue&type=script&setup=true&lang=js"
export * from "./Metodologias.vue?vue&type=script&setup=true&lang=js"

import "./Metodologias.vue?vue&type=style&index=0&id=0f6aab96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6aab96"]])

export default __exports__